import Role from 'models/core/role/Model.Role';
import Model from 'models/Model';
import claimJobEmailTemplateListApi from './list/Api.ClaimJobEmailTemplate.List';
import claimJobEmailTemplateSaveApi from './save/Api.ClaimJobEmailTemplate.Save';
import claimJobEmailTemplateDeleteApi from './delete/Api.ClaimJobEmailTemplate.Delete';

export default class ClaimJobEmailTemplate
  extends Model<Model.IClaimJobEmailTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimJobEmailTemplate>
{
  id: number;
  name: string;
  claimJobStatus: Model.Enum.ClaimJobStatusCode;
  senderEmail: string;
  senderName: string;
  subject: string;
  htmlBody: string;
  recipientsWithRole?: Role[];

  sendToClient = false;
  sendToContactEmail = false;
  sendToClaimOwner = false;
  additionalRecipientEmails: string[] = [];

  languageIsoCode?: Locale.Languages;
  readonly baseEntityId: number;

  constructor(
    data: Partial<Model.IClaimJobEmailTemplate> | Utils.FormData<Model.IClaimJobEmailTemplate>,
    language?: Locale.Languages
  ) {
    super(
      {
        recipientsWithRole: [Role],
      },
      language
    );
    this.update(data);
    if (!this.additionalRecipientEmails) this.additionalRecipientEmails = [];
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name,
      info: this.senderName,
      subtitle: this.senderEmail,
    };
  }
  static async list(body?: Api.Core.ClaimJobEmailTemplate.List.IRequest) {
    const { payload, ...rest } = await claimJobEmailTemplateListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ClaimJobEmailTemplate(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await claimJobEmailTemplateSaveApi(this);
  }
  async delete() {
    return await claimJobEmailTemplateDeleteApi(this.id);
  }
}
